import Header from '../components/general/Header';
import Footer from '../components/general/Footer';
import UpcomingShows from '../components/shows/UpcomingShows';
import JoinFans from '../components/shows/JoinFans';
import NoShows from '../components/shows/NoShows';
import useIsMobile from '../utils/hooks/useIsMobile';
import s from '../styles/pages/Shows.module.css';
import site from '../data/master.json';

function todayIso() {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mm}-${dd}`;
}

export default function Shows() {
  const isMobile = useIsMobile();
  const today = todayIso();
  const upcoming = site.shows.items.filter((show) => show.date >= today);

  return (
    <div className={s.container}>
      <Header />
      {upcoming.length > 0 ? (
        <main className={isMobile ? s.innerMobile : s.inner}>
          <h1 className={isMobile ? s.titleMobile : s.title}>{site.shows.title}</h1>
          <UpcomingShows data={{ ...site.shows, items: upcoming }} />
          <JoinFans data={site.joinFans} />
        </main>
      ) : (
        <NoShows data={site.noShows} images={site.experience.tiles} />
      )}
      <Footer data={site.footer} />
    </div>
  );
}